<nav mat-tab-nav-bar>
  <a
    mat-tab-link
    [routerLink]="['./flights']"
    routerLinkActive
    #rla1="routerLinkActive"
    [active]="rla1.isActive"
  >
    <mat-icon matListIcon>flight</mat-icon>&nbsp;&nbsp;&nbsp;Voli
  </a>
  <a
    mat-tab-link
    [routerLink]="['./accomodations']"
    routerLinkActive
    #rla2="routerLinkActive"
    [active]="rla2.isActive"
  >
    <mat-icon matListIcon>hotel</mat-icon>&nbsp;&nbsp;&nbsp;Alloggi
  </a>
  <a
    mat-tab-link
    [routerLink]="['./trains']"
    routerLinkActive
    #rla3="routerLinkActive"
    [active]="rla3.isActive"
  >
    <mat-icon matListIcon>train</mat-icon>&nbsp;&nbsp;&nbsp;Treni
  </a>
  <a
    mat-tab-link
    [routerLink]="['./ferries']"
    routerLinkActive
    #rla4="routerLinkActive"
    [active]="rla4.isActive"
  >
    <mat-icon matListIcon>directions_boat</mat-icon>&nbsp;&nbsp;&nbsp;Navi
  </a>
  <a
    mat-tab-link
    [routerLink]="['./buses']"
    routerLinkActive
    #rla5="routerLinkActive"
    [active]="rla5.isActive"
  >
    <mat-icon matListIcon>directions_bus</mat-icon>&nbsp;&nbsp;&nbsp;Autobus
  </a>
  <a
    mat-tab-link
    [routerLink]="['./cars']"
    routerLinkActive
    #rla6="routerLinkActive"
    [active]="rla6.isActive"
  >
    <mat-icon matListIcon>directions_car</mat-icon>&nbsp;&nbsp;&nbsp;Altri mezzi
  </a>
</nav>

<router-outlet></router-outlet>
